/**
 * A navigation entry with a submenu links to its own page where the submenu
 * opens on hover (docs/features/DROPDOWN_PARENT_LINK.md).
 *
 * The parent of a subtree is a Bootstrap dropdown toggle with a real href.
 * Bootstrap's delegated click handler prevents the navigation, and on an
 * expanded navbar Around opens the menu on hover and hides a menu a click
 * opened, so the click there does nothing visible at all. With the record
 * booost.navigation_dropdown_parent_link on, the navigation tile marks its
 * list `data-parent-link`; inside it, on an expanded navbar with a mouse, a
 * click on the toggle is stopped on its way down at `window`, and the browser
 * follows the link. Not on `document`: Bootstrap registers its delegated
 * handlers there in the capture phase too (EventHandler passes
 * `useCapture = isDelegated`), and it was there first, so a listener on
 * `document` would only run after Bootstrap had already prevented the
 * navigation. `window` comes before `document` in the capture path.
 *
 * Collapsed navbar (offcanvas, phone) and touch screens keep the toggle: there
 * the click is the only way into the submenu. Enter on a focused toggle is a
 * click and follows the same rule; Arrow Down is Bootstrap's keydown handler
 * and stays untouched.
 *
 * One capture listener on `window`, so the header can arrive over htmx
 * without anything to bind again.
 */

const PARENT_LINK_TOGGLE =
  '[data-parent-link] .dropdown > .dropdown-toggle[href]'

// Bootstrap's grid breakpoints, used when the stylesheet carries no
// --ar-breakpoint-* custom properties
const GRID_BREAKPOINTS = { sm: 576, md: 768, lg: 992, xl: 1200, xxl: 1400 }

/*
 * The min-width at which the navbar is expanded: 0 for `navbar-expand`,
 * the breakpoint's width for `navbar-expand-<bp>`, null when the navbar never
 * expands (no navbar-expand class at all).
 */
function navbarExpandWidth(navbar, win) {
  if (!navbar || !navbar.classList) return null
  let width = null
  navbar.classList.forEach((name) => {
    const match = /^navbar-expand(?:-(sm|md|lg|xl|xxl))?$/.exec(name)
    if (!match) return
    if (!match[1]) {
      width = 0
      return
    }
    let value = NaN
    try {
      value = parseFloat(
        win
          .getComputedStyle(win.document.documentElement)
          .getPropertyValue(`--ar-breakpoint-${match[1]}`)
      )
    } catch (e) {
      value = NaN
    }
    width = Number.isFinite(value) ? value : GRID_BREAKPOINTS[match[1]]
  })
  return width
}

/*
 * Whether a click on this toggle follows its href: the navbar is expanded
 * and the device hovers with a fine pointer.
 */
function followsParentLink(toggle, win) {
  const href = toggle.getAttribute('href')
  if (!href || href.charAt(0) === '#') return false
  const width = navbarExpandWidth(toggle.closest('.navbar'), win)
  if (width === null) return false
  if (width > 0 && !win.matchMedia(`(min-width: ${width}px)`).matches)
    return false
  return win.matchMedia('(hover: hover) and (pointer: fine)').matches
}

window.addEventListener(
  'click',
  (event) => {
    if (event.defaultPrevented || event.button > 0) return
    const target = event.target
    if (!target || typeof target.closest !== 'function') return
    const toggle = target.closest(PARENT_LINK_TOGGLE)
    if (!toggle || !followsParentLink(toggle, window)) return
    event.stopPropagation()
  },
  true
)
